<template>
	<strong class="card_value">
		<slot></slot>
	</strong>
</template>

<script type="text/babel">
export default {};
</script>
